module.exports = __webpack_public_path__ + "static/grilled-cheese-b-m-b8813b62c343a4f0c1e79803eeb7f9bb.png";